// extracted by mini-css-extract-plugin
module.exports = {"field-container":"dd31006766--field-container--eWIcF","title":"dd31006766--title--REZ5k","mobile":"dd31006766--mobile--qFDri","empty":"dd31006766--empty--nl7CI"};